"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanErrorObject = exports.isAlphanumeric = void 0;
var lodash_1 = __importDefault(require("lodash"));
function isAlphanumeric(input) {
    var regexp = /^[a-zA-Z0-9-_]+$/;
    return input.search(regexp) !== -1;
}
exports.isAlphanumeric = isAlphanumeric;
/**
 * Takes an object and removes keys with values that are null or an empty object.
 * This is done arbitrary deep.
 */
var cleanErrorObject = function (obj) {
    if (!obj || !(typeof obj === 'object')) {
        return undefined;
    }
    var objCleaned = lodash_1.default.cloneDeep(obj);
    Object.keys(objCleaned || {}).forEach(function (key) {
        if (typeof objCleaned[key] === 'object') {
            var cleaned_1 = (0, exports.cleanErrorObject)(objCleaned[key]);
            objCleaned[key] =
                Object.keys(cleaned_1 || {}).length > 0 ? cleaned_1 : undefined;
        }
    });
    var cleaned = lodash_1.default.pickBy(objCleaned, lodash_1.default.identity);
    return Object.keys(cleaned || {}).length > 0 ? cleaned : undefined;
};
exports.cleanErrorObject = cleanErrorObject;
//# sourceMappingURL=helpers.js.map